const limit = {
    RECENT_SEARCHES_LIMIT: 10,
    SEARCH_LIMIT: 10,
};
export default limit;

